import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import Contact from "../contact/models/contact"
import { INTEGRATION_KEY } from "./Constants"

class ContactImportableService {

    static async importContactsFromExternalSale(integrationKey: INTEGRATION_KEY, externalSaleId: string): Promise<Contact[]> {
        const res = await AppContext.getApiClient().post(`/${integrationKey}/external-sales/${externalSaleId}/import-contacts`, {})

        return new Promise((resolve, reject) => {
            if (res.error) {
                reject(new Error(res.error.message))
            } else {
                resolve(res.data.map(contact => new Contact(contact)))
            }
        })
    }
}

export default ContactImportableService


// WEBPACK FOOTER //
// ./src/state/integration/ContactImportableService.ts